import { useAdDetails } from './useAdDetails';
import { AdDetails } from '@/api/types/ads.types';

interface UseIsShopOptions {
  cacheOnly?: boolean;
}

export function useIsShop(
  initialAdDetails?: AdDetails | null,
  { cacheOnly = false }: UseIsShopOptions = {}
) {
  const { adDetails } = useAdDetails({ cacheOnly });
  const { shop } = adDetails ?? initialAdDetails ?? {};

  return !!shop;
}
